<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_orderrefund"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="orderDetailRefund_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="orderDetailRefund_statusQuery_button"
          @click="statusQuery"
        >
          更新结果
        </el-button>
        <el-button v-if="orderDetailRefund_export_button" @click="funcExport()">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      show-overflow
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      sort-config.remote
      export-config
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column title="基本信息">
        <vxe-table-column>
          <vxe-table-column
            field="branchCode"
            title="承运主体"
            :formatter="formatterBranch"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.branchCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in branchList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="orderDetailNumber"
            title="运输单号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.orderDetailNumber"
              placeholder="请输入运输单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="payType"
            title="支付方式"
            min-width="120"
            sortable
            :formatter="formatterPayType"
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.payType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in payTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="amount"
            title="退款金额(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.amountStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.amountEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="partyName"
            title="收款方姓名"
            min-width="120"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.partyName"
              placeholder="请输入收款方姓名"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="partyPhone"
            title="收款方手机号"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.partyPhone"
              placeholder="请输入收款方手机号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="status"
            title="状态"
            min-width="120"
            sortable
            :formatter="formatterStatus"
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.status"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="info"
            title="描述"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.info"
              placeholder="请输入描述"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="gmtCreated"
            title="创建时间"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </vxe-table-column>
      </vxe-table-column>
      <vxe-table-column title="分账退回信息">
        <!-- <vxe-table-column>
              <vxe-table-column field="shareRefundShareType" title="0分账" min-width="300" sortable />
              <template v-slot:header>
                  <el-input v-model="listQuery.shareRefundShareType" placeholder="请输入0分账" clearable />
              </template>
          </vxe-table-column> -->
        <vxe-table-column>
          <vxe-table-column
            field="merchantId"
            title="原支付订单收款商户号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.merchantId"
              placeholder="请输入原支付订单收款商户号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shareRefundRelateOrderNo"
            title="原支付订单号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shareRefundRelateOrderNo"
              placeholder="请输入原支付订单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="outTradeNo"
            title="外部订单流水号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.outTradeNo"
              placeholder="请输入外部订单分账请求流水号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shareRefundOrderNo"
            title="网商分账退回订单号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shareRefundOrderNo"
              placeholder="请输入网商分账退回订单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shareRefundStatus"
            title="状态"
            min-width="120"
            sortable
            :formatter="formatterStatus"
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.shareRefundStatus"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shareRefundDate"
            title="分账退回时间"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.shareRefundDateRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'shareRefundDate')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shareRefundErrorCode"
            title="错误码"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shareRefundErrorCode"
              placeholder="请输入错误码"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shareRefundErrorDesc"
            title="错误描述"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shareRefundErrorDesc"
              placeholder="请输入错误描述"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shareRefundPartyName"
            title="收款方姓名"
            min-width="120"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shareRefundPartyName"
              placeholder="请输入收款方姓名"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shareRefundPartyPhone"
            title="收款方手机号"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shareRefundPartyPhone"
              placeholder="请输入收款方手机号"
              clearable
            />
          </template>
        </vxe-table-column>
      </vxe-table-column>
      <vxe-table-column title="网商支付退回信息">
        <!-- <vxe-table-column>
              <vxe-table-column field="shareType" title="0余额支付" min-width="300" sortable />
              <template v-slot:header>
                  <el-select v-model="listQuery.shareType" clearable placeholder="请选择">
                    <el-option v-for="item in shareTypes" :key="item.value" :label="item.label" :value="item.value"/>
                  </el-select>
              </template>
          </vxe-table-column> -->
        <vxe-table-column>
          <vxe-table-column
            field="participantType"
            title="退款付方类型"
            min-width="150"
            sortable
            :formatter="formatterParticipantType"
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.participantType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in participantTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="relateOrderNo"
            title="原支付订单号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.relateOrderNo"
              placeholder="请输入原支付订单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="relateTransNo"
            title="支付流水号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.relateTransNo"
              placeholder="请输入支付流水号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="outRefundNo"
            title="退款外部交易号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.outRefundNo"
              placeholder="请输入退款外部交易号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="payRefundStatus"
            title="状态"
            min-width="120"
            sortable
            :formatter="formatterStatus"
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.payRefundStatus"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="refundOrderNo"
            title="退款网商订单号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.refundOrderNo"
              placeholder="请输入退款网商订单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="refundFinishDate"
            title="退款完成时间"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.refundFinishDateRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'refundFinishDate')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="channelRefundOrderNo"
            title="渠道退款单号"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.channelRefundOrderNo"
              placeholder="请输入渠道退款单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="participantActualRefundAmount"
            title="商户实际退款金额"
            min-width="180"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.participantActualRefundAmount"
              placeholder="请输入商户实际退款金额"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="errorCode"
            title="错误码"
            min-width="120"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.errorCode"
              placeholder="请输入错误码"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="errorDesc"
            title="错误描述"
            min-width="300"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.errorDesc"
              placeholder="请输入错误描述"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="payRefundPartyName"
            title="收款方姓名"
            min-width="120"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.payRefundPartyName"
              placeholder="请输入收款方姓名"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="payRefundPartyPhone"
            title="收款方手机号"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.payRefundPartyPhone"
              placeholder="请输入收款方手机号"
              clearable
            />
          </template>
        </vxe-table-column>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" min-width="140">
        <template slot-scope="scope">
          <el-tooltip
            v-if="orderDetailRefund_detail_button"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <template
            v-if="
              orderDetailRefund_shareRefund_button &&
                scope.row.payType == 'online' &&
                scope.row.status != 'SUCCESS'
            "
          >
            <el-tooltip
              v-if="scope.row.shareRefundStatus != 'SUCCESS'"
              class="item"
              effect="dark"
              content="分账退回"
              placement="top"
            >
              <vxe-button type="text" @click="shareStatusQuery(scope.row.code)">
                <i class="el-icon-refresh-left" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                orderDetailRefund_payRefund_button &&
                  scope.row.payRefundStatus != 'SUCCESS'
              "
              class="item"
              effect="dark"
              content="支付退回"
              placement="top"
            >
              <vxe-button type="text" @click="payStatusQuery(scope.row.code)">
                <i class="el-icon-refresh-right" />
              </vxe-button>
            </el-tooltip>
          </template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="800"
      height="800"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <el-dialog
      title="失败信息"
      :visible.sync="dialogTableVisible"
      class="abow_dialog"
    >
      <el-table :data="errorData" height="100%" border>
        <el-table-column property="code" label="订单号" width="290" />
        <el-table-column property="msg" label="错误描述" width="300" />
      </el-table>
    </el-dialog>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
// import compShareDetail from './components/mybankOrderShareRefundDetail.vue'
// import compPayDetail from './components/mybankPayRefundDetail.vue'
import compDetail from "./components/orderDetailRefundDetail.vue";
import request from "@/utils/request";
import { getLimit } from "@/utils/getLimit.js";
export default {
  name: "OrderDetailRefundList",
  components: {
    // compShareDetail,
    // compPayDetail,
    compDetail
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetailRefund/exportOrderDetailRefund", //导出接口
        name: "财务驳回"
      },
      message: "",
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      orderDetailRefund_search_button: false, //查询
      orderDetailRefund_export_button: false, //导出
      orderDetailRefund_statusQuery_button: false, //更新结果
      orderDetailRefund_detail_button: false, //详情
      orderDetailRefund_shareRefund_button: false, //分账退回
      orderDetailRefund_payRefund_button: false, //支付退回
      copy: false,
      listQuery: {
        gmtCreatedRange: [],
        shareRefundDateRange: [],
        refundFinishDateRange: [],
        code: "",
        orderDetailCode: "",
        orderDetailNumber: "",
        payType: "",
        amount: "",
        partyCode: "",
        partyName: "",
        partyPhone: "",
        status: "",
        info: "",
        branchCode: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      dialogTableVisible: false,
      errorData: [],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      payTypes: [
        { value: "platform", label: "平台余额" },
        { value: "online", label: "在线支付" }
      ],
      statusOptions: [
        { value: "SUCCESS", label: "成功" },
        { value: "FAIL", label: "失败" },
        { value: "DEALING", label: "处理中" }
      ],
      participantTypes: [
        { value: "MERCHANT", label: "商户" },
        { value: "PLATFORM", label: "平台" }
      ],
      shareTypes: [{ value: "0", label: "余额支付" }]
    };
  },
  async created() {
    this.findList();
    this.orderDetailRefund_search_button = getLimit(
      "orderDetailRefund_search_button"
    );
    this.orderDetailRefund_export_button = getLimit(
      "orderDetailRefund_export_button"
    );
    this.orderDetailRefund_statusQuery_button = getLimit(
      "orderDetailRefund_statusQuery_button"
    );
    this.orderDetailRefund_detail_button = getLimit(
      "orderDetailRefund_detail_button"
    );
    this.orderDetailRefund_shareRefund_button = getLimit(
      "orderDetailRefund_shareRefund_button"
    );
    this.orderDetailRefund_payRefund_button = getLimit(
      "orderDetailRefund_payRefund_button"
    );
  },
  methods: {
    //支付状态查询
    statusQuery() {
      const rLoading = this.openLoading();
      let selectRecords = this.$refs.xTable.getCheckboxRecords();
      let codes = "";
      if (selectRecords.length > 0) {
        codes = [];
        for (const key in selectRecords) {
          codes.push(selectRecords[key].code);
        }
      }
      if (codes) {
        codes = codes.join(",");
      }
      request({
        url: "/ntocc-tms-api/orderDetailRefund/batchUpdate",
        method: "put",
        params: { codes: codes }
      }).then(response => {
        rLoading.close();
        if (response.status === 500) {
          this.dialogTableVisible = true;
          this.errorData = response.data;
        } else {
          let type = response.status === 0 ? "success" : "warning";
          this.findList();
          this.$message({
            message: response.msg,
            type: type
          });
        }
      });
    },
    // 分账退回
    shareStatusQuery(code) {
      const rLoading = this.openLoading();
      request({
        url: "/ntocc-tms-api/mybankOrderShareRefund/refund",
        method: "post",
        params: { code: code }
      }).then(response => {
        rLoading.close();
        if (response.status === 500) {
          this.dialogTableVisible = true;
          this.errorData = response.data;
        } else {
          let type = response.status === 0 ? "success" : "error";
          this.findList();
          this.$message({
            message: response.msg,
            type: type
          });
        }
      });
    },
    // 支付退回
    payStatusQuery(code) {
      const rLoading = this.openLoading();
      request({
        url: "/ntocc-tms-api/mybankPayRefund/refund",
        method: "post",
        params: { code: code }
      }).then(response => {
        rLoading.close();
        if (response.status === 500) {
          this.dialogTableVisible = true;
          this.errorData = response.data;
        } else {
          let type = response.status === 0 ? "success" : "error";
          this.findList();
          this.$message({
            message: response.msg,
            type: type
          });
        }
      });
    },
    findList() {
      this.loading = true;
      return request({
        url: "/ntocc-tms-api/orderDetailRefund",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    // 详情方法
    funcDetail(code) {
      let dicts = {
        branchList: this.branchList,
        payTypes: this.payTypes,
        statusOptions: this.statusOptions,
        participantTypes: this.participantTypes,
        shareTypes: this.shareTypes
      };
      this.$refs.detailRef.getInfo(code, dicts);
      this.modelDetailFlag = true;
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 底部颜色设置
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterParticipantType({ cellValue }) {
      const item = this.participantTypes.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterPayType({ cellValue }) {
      const item = this.payTypes.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            ["amount", "participantActualRefundAmount"].includes(
              column.property
            )
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    }
  }
};
</script>
